import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useWindow from '../../hooks/useWindow'
import { singleDoubleChartWidth, chartHeight, post2, list2 } from '../../services';
import exportingModule from "highcharts/modules/exporting";
import exportDataModule from 'highcharts/modules/export-data'
import moment from 'moment';
exportingModule(Highcharts);
exportDataModule(Highcharts);


export const CftcChangeChart = ({ param }) => {
    const [options, setOptions] = useState({})
    const size = useWindow()

    const [exp, setExp] = useState(false)
    useEffect(() => {
        async function fetch() {
            const auth = await list2('auth')
            setExp(auth === true)
        }
        fetch()
    }, [])

    useEffect(() => {
        const { name, product, data: alldata } = param
        const data = alldata.slice(-8)
        const options = {
            chart: {
                type: 'bar',
                width: singleDoubleChartWidth(size.width),
                height: 400
            },
            exporting: exp ? {
                buttons: {
                    contextButton: {
                        enabled: true,
                        align: 'left',
                        menuItems: ["downloadPNG", "downloadPDF", "downloadCSV", "separator",
                            {   
                                text: 'Send Email', 
                                onclick: function() {
                                    const csv = this.getCSV()
                                    const html = this.getSVG()
                                    const title = this.getFilename()
                                    post2('user/export_file', { csv, html, title })
                                } 
                            }
                        ]
                    }
                }
            } : {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            title: { text: `${name} Changes` },
            subtitle: { text: `Positions of ${product}`, align: 'right' },
            xAxis: {
                title: { text: '' },
                categories: data.map(({ date }) => moment(date).format('MMM DD')),
                tickInterval: Math.round(data.length/12)
            },
            yAxis: {
                title: { text: '%' }
            },
            tooltip: {
                formatter: function() {
                    return `<small>${this.x}</small><br/><span style="color:${this.color}">●</span>&nbsp;${this.series.name}: <b>${this.y.toFixed(1)} %</b>`
                }
            },
            series: [
                { name: `Long Weekly Change`, color: '#00b050', data: data.map((dat) => dat['Long diff']) },
                { name: `Short Weekly Change`, color: '#e5633f', data: data.map((dat) => -dat['Short diff']) }
            ]
        }
        setOptions(options)
        // console.log(options)
    }, [param, size, exp])

    return <div className='row-center'>
        <HighchartsReact highcharts={Highcharts} options={options} />
    </div>

}